// extracted by mini-css-extract-plugin
export default {"wrapper":"oZMCk_cR","_shorts":"dLnnU6rV","caption":"V1eVcqgF","video":"gkXcZqWE"};